import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { target: 100, suffix: "%", label: "Einsatz" },
  { target: 100, suffix: "%", label: "Zufriedenheit"},
  { target: null, suffix: "∞", label: "Ideen" },
];

export const Stats = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      ref={ref}
      id="stats"
      data-testid="stats-section"
      data-glow="stats"
      className="relative z-10 px-6 sm:px-10 lg:px-20 py-20 lg:py-28 max-w-[1500px] mx-auto"
    >
      <div className="grid grid-cols-3 gap-x-6 sm:gap-x-16 gap-y-12 max-w-3xl mx-auto text-center">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`stat-${i}`}
          >
            <div className="flex items-baseline justify-center gap-1">
              {s.target !== null && <CountUp value={s.target} active={inView} />}
              <span
                className="font-display font-medium leading-none text-amber"
                style={{
                  fontSize: s.target !== null
                    ? "clamp(36px, 6vw, 72px)"
                    : "clamp(48px, 8vw, 96px)",
                }}
              >
                {s.suffix}
              </span>
            </div>
            <div className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-mute">
              {s.label}
            </div>
            <div
              className="mt-5 h-px w-12 mx-auto"
              style={{ background: "rgba(244,152,0,0.5)" }}
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

const CountUp = ({ value, active }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!active) return;
    const duration = 1800;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      setN(Math.round(eased * value));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, value]);

  return (
    <span
      className="font-display font-medium leading-none text-amber tabular-nums"
      style={{ fontSize: "clamp(48px, 8vw, 96px)" }}
    >
      {n}
    </span>
  );
};
